export function deletionReasonError(value: string): string {
  const reason = value.trim();
  if (!reason) return '刪除原因必填，且不可超過 500 字。';
  if (reason.length > 500) return '刪除原因必填，且不可超過 500 字。';
  return '';
}
